module.exports = __webpack_public_path__ + "img/2.b47c6e33.png";